export const isNotFoundError = (error: Error | string) => {
  const errorMessage = typeof error === "string" ? error : error?.message;
  return !!errorMessage.includes("error.not-found");
};
